import React from "react";

export const Card = React.forwardRef(({ className = "", ...props }, ref) => (
	<div ref={ref} className={`grader-card ${className}`.trim()} {...props} />
));
Card.displayName = "Card";

export const CardHeader = React.forwardRef(({ className = "", ...props }, ref) => (
	<div ref={ref} className={`grader-card__header ${className}`.trim()} {...props} />
));
CardHeader.displayName = "CardHeader";

export const CardTitle = React.forwardRef(({ className = "", ...props }, ref) => (
	<h3 ref={ref} className={`grader-card__title ${className}`.trim()} {...props} />
));
CardTitle.displayName = "CardTitle";

export const CardDescription = React.forwardRef(({ className = "", ...props }, ref) => (
	<p ref={ref} className={`grader-card__description ${className}`.trim()} {...props} />
));
CardDescription.displayName = "CardDescription";

export const CardContent = React.forwardRef(({ className = "", flushTop, ...props }, ref) => (
	<div
		ref={ref}
		className={`grader-card__content${flushTop ? " grader-card__content--flush-top" : ""} ${className}`.trim()}
		{...props}
	/>
));
CardContent.displayName = "CardContent";

export const CardFooter = React.forwardRef(({ className = "", ...props }, ref) => (
	<div ref={ref} className={`grader-card__footer ${className}`.trim()} {...props} />
));
CardFooter.displayName = "CardFooter";
